module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero-variation-afl50.b1a0fa06.jpg";